import React, { useContext } from "react";
import './Spinner.css';
import { AppContext } from "../../appContext";

interface ISpinnerProps{

}

export const Spinner = ({}: ISpinnerProps)=>{
    const { translate } = useContext(AppContext);
    
    return <div className={`commonSpinner`}>
        <div className={`commonSpinner_loader`}></div>
        {translate('loading')}
    </div>
}